import { ClientesNotificacoesModel } from "./clientes-notificacoes.model";
import { ClientesNotificacoesFinanceiroModel } from "./clientes-notificacoes-financeiro.model";

export class ClientesModel {
  id_cliente: number;
  id_pais: number = null;
  nome: string;
  nome_tratamento: string;
  cnpj: string;
  endereco: string;
  cep: string;
  bairro: string;
  cidade: string;
  estado: string;
  telefone: string;
  responsavel: string;
  celular: string;
  site: string;
  email: string;
  notificacoes: ClientesNotificacoesModel[];
  notificacoes_financeiro: ClientesNotificacoesFinanceiroModel[];
  tipos = [];
  visibilidades = [];
  taxas_mercadorias: any[] = [];
  forma_pagamento: string = 'deposito';
  id_moeda: number = null;
  valor_preliminares: string;
  valor_laudo_pdf: string;
  valor_laudoscd: string;
  valor_laudoscd_fixo: string = '0,00';
  valor_laudostecnicos: string;
  taxa_laboratorial: string;
  tipo_faturamento_mi: string = 'taxa_fixa';
  valor_mi_taxa_fixa: string;
  id_banco: number = null;
  faturamento_tipo: string = 'multiplo';
  periodo_faturamento: string = 'mensal';
  prazo_pagamento_boleto: number = 15;
  prazo_pagamento_deposito: number = 15;
  com_nota_fiscal: boolean = false;
  idioma: string = 'pt';
}



// WEBPACK FOOTER //
// ./src/app/clientes/clientes.model.ts